// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__k2yXy","inner":"List_inner__Ua7NJ"};